<template>
    <div class="notifications-group">
        <h2 class="notifications-group__name" v-text="title" />
        <div class="notifications-group__items">
            <div v-for="item in items" :key="itemKey(item)" class="notifications-group__item">
                <slot name="item" :item="item" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'NotificationsGroup',
    props: {
        title: {
            type: String,
            default: '',
        },
        items: {
            type: Array,
            default: () => [],
        },
        itemKey: {
            type: Function,
            default: ({ id }) => id,
        },
    },
};
</script>

<style lang="scss" src="./NotificationsGroup.scss"></style>
